import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postApiCall } from "../Utils/Utils";
import { useOktaAuth } from "@okta/okta-react";
import { countryMap } from "./SubheaderConstants";
import { Spinner } from "react-bootstrap";
import { setAccountInfo } from "../../../redux/AccountInfoSlice";
import Tooltip from "@mui/material/Tooltip";
export const Subheader = () => {
  const dispatch = useDispatch();
  const { oktaAuth, authState } = useOktaAuth();
  const [currencyLoader, setcurrencyLoader] = useState(false);
  const updatedAccountInfo = useSelector((state) => state.account.accountInfo);
  useEffect(() => {
    const sessionData = sessionStorage.getItem("account_info");
    const parsedInfo = sessionData ? JSON.parse(sessionData) : null;

    if (parsedInfo && !updatedAccountInfo?.client) {
      dispatch(setAccountInfo(parsedInfo));
    }
  }, []);
  useEffect(() => {
    if (
      updatedAccountInfo?.client &&
      updatedAccountInfo?.fb_account_id &&
      !updatedAccountInfo?.currency
    ) {
      fetchCurrency(updatedAccountInfo);
    }
  }, [updatedAccountInfo]);

  const fetchCurrency = async (accountInfo) => {
    if (!accountInfo?.client || !accountInfo?.fb_account_id) return;
    setcurrencyLoader(true);
    try {
      const payload = {
        client: accountInfo.client || "",
        account_id: accountInfo.fb_account_id || "",
      };
      const catalogCurrencyUrl = "/api/meta-catalog-currency/";
      const catalogCurency = await postApiCall(
        oktaAuth,
        catalogCurrencyUrl,
        payload
      );

      const newAccountInfo = {
        ...accountInfo,
        currency: catalogCurency.currency,
        country: catalogCurency.business_country_code,
      };
      sessionStorage.setItem("account_info", JSON.stringify(newAccountInfo));
      dispatch(setAccountInfo(newAccountInfo));
    } catch (e) {
      console.log(e);
    } finally {
      setcurrencyLoader(false);
    }
  };
  //   if (!updatedAccountInfo) return null;
  const truncateText = (text, maxLength = 20) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  return (
    <div className="subheader">
      <div className="subheader-item">
        <span>⚡</span>
        <Tooltip title={updatedAccountInfo?.fb_account_name || ""} arrow>
          <span>
            <b>Account Name:</b>{" "}
            {truncateText(updatedAccountInfo?.fb_account_name) || ""}
          </span>
        </Tooltip>
      </div>
      <div className="subheader-item">
        <span>💼</span>
        <Tooltip title={updatedAccountInfo?.fb_account_id || ""} arrow>
          <span>
            <b>Account Id:</b>{" "}
            {truncateText(updatedAccountInfo?.fb_account_id) || ""}
          </span>
        </Tooltip>
      </div>
      <div className="subheader-item">
        <span>📦</span>
        <Tooltip title={updatedAccountInfo?.fb_catelog_name || ""} arrow>
          <span>
            <b>Catalog:</b>{" "}
            {truncateText(updatedAccountInfo?.fb_catelog_name) || ""}
          </span>
        </Tooltip>
      </div>
      <div className="subheader-item">
        <span>📦</span>
        <Tooltip title={updatedAccountInfo?.fb_catelog_id || ""} arrow>
          <span>
            <b>Catalog Id:</b>{" "}
            {truncateText(updatedAccountInfo?.fb_catelog_id) || ""}
          </span>
        </Tooltip>
      </div>
      <div className="subheader-item">
        <span>💰</span>
        <span>
          <b>Currency:</b>{" "}
          {currencyLoader ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              className="ms-2"
            />
          ) : (
            // updatedAccountInfo?.currency || ""
            <Tooltip title={updatedAccountInfo?.currency || ""} arrow>
              <span>
                {truncateText(updatedAccountInfo?.currency) || ""}
              </span>
            </Tooltip>
          )}
        </span>
      </div>
      <div className="subheader-item">
        <span>🌎</span>
        <span>
          <b>Country:</b>{" "}
          {currencyLoader ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              className="ms-2"
            />
          ) : (
            // countryMap[updatedAccountInfo?.country] || ""
            <Tooltip
              title={countryMap[updatedAccountInfo?.country] || ""}
              arrow
            >
              <span>
                {truncateText(countryMap[updatedAccountInfo?.country]) || ""}
              </span>
            </Tooltip>
          )}
        </span>
      </div>
    </div>
  );
};
